import React from 'react';
import { arrayOf, node, oneOfType, string } from 'prop-types';
import { Button } from '@thd-olt-component-react/button';
import '../hdhome-catalog-promo.scss';

const Promo = (props) => {
  const {
    children,
    title,
    link,
    linkText,
    emailComponent
  } = props;

  const ctaLink = (url, text) => {
    if (!url && !text) return null;
    return (
      <div className="hdhome-catalog-promo__link">
        <Button outline onClick={(evt) => { window.location = url; }}>{text}</Button>
      </div>
    );
  };

  return (
    <div className="hdhome-catalog-promo__item">
      <div className="hdhome-catalog-promo__copy">
        <span className="hdhome-catalog-promo__email-icon" />
        <span className="hdhome-catalog-promo__title-header">
          {title && <h3 className="hdhome-catalog-promo__title">{title}</h3>}
        </span>
        <span className="hdhome-catalog-promo__content">{ children }</span>
      </div>
      <div className="hdhome-catalog-promo__action">
        { ctaLink(link, linkText) }
        {emailComponent}
      </div>
    </div>
  );
};

Promo.propTypes = {
  children: oneOfType([
    node,
    arrayOf(node)
  ]).isRequired,
  link: string,
  linkText: string,
  title: string,
  emailComponent: oneOfType([
    node,
    arrayOf(node)
  ])
};

Promo.defaultProps = {
  link: null,
  linkText: null,
  title: null,
  emailComponent: null
};

export { Promo };
